import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './redux/store';
import './index.css';
import './assets/css/app.min.css';
import App from "./App"
import SaveLater from '../src/Components/Modals/OrderQuote/SaveLater';
import AddCustomer from '../src/Components/Modals/LeadCustomer/AddCustomer';
import BuildingType from '../src/Components/Modals/BuildingType/BuildingType';
import WhatThis from '../src/Components/Modals/WhatThis';
import TermsCondition from '../src/Components/Modals/TermsCondition';
import SummaryModal from '../src/Components/Modals/SummaryModal';
import Feedback from '../src/Components/Modals/Feedback';
import WelcomeModal from '../src/Components/Modals/WelcomeModal';
import SharingAlertBox from '../src/Components/Modals/AlertBox/SharingAlertBox';
import EditOrderQuote from '../src/Components/Modals/AlertBox/EditOrderQuote';
import ScreenCaptureConfirm from '../src/Components/Modals/ScreenCaptureConfirm';
import SuccessOq from '../src/Components/Modals/SuccessOq';
import LayoutDesign from '../src/Components/Modals/LayoutDesign';
import HowToUseDoorWindowInDevice from '../src/Components/Modals/DoorWindow/HowToUseDoorWindowInDevice';
import ComparePriceModal from './Components/Modals/ComparePriceModal';
import PhotosModal from './Components/ControlPanel/Photos/PhotosModal';
import ShareModal from './Components/Modals/ShareModal';

import { handleShowOverlay } from './action';
import DiscountsModal from './Components/Header/DiscountsModal';
import Toaster from './screen-share/components/Toaster.tsx';
import Join from './screen-share/components/join/Join.tsx';
import DeletedStateManuModal from './Components/Modals/DeletedStateManuModal.js';
import MobileARLanding from './Components/AR/MobileARLanding.js';

const CustomRoutes = () => {
  const state = useSelector((state) => state.reducer);
  const dispatch = useDispatch();

  let DomainURI = window.location.href.split("#/");

  if (DomainURI?.[1]?.includes && DomainURI?.[1]?.includes("join")) {
    return (
      <>
        <Toaster />
        <Join />
      </>
    );
  }

  if (DomainURI?.[1]?.includes && DomainURI?.[1]?.includes("ar-view")) {
    return <MobileARLanding />;
  }

  return (
    <>
      <App />
      <Toaster />
      <SaveLater />

      <AddCustomer />

      <SummaryModal />

      <PhotosModal />

      <DiscountsModal />

      <ComparePriceModal />

      <ShareModal />

      <WelcomeModal />

      <Feedback />

      {/* <ReportIssueComp/> */}

      <DeletedStateManuModal />

      <SharingAlertBox />

      <WhatThis />

      <ScreenCaptureConfirm />

      <BuildingType />

      <HowToUseDoorWindowInDevice />

      <SuccessOq />

      <LayoutDesign />

      <EditOrderQuote />

      <div className={state.isShowOverlay ? 'global-overlay' : 'd-none global-overlay'} onClick={(e) => dispatch(handleShowOverlay(false))}></div>

    </>
  )
}

export default CustomRoutes;